import { RedoCartCheckoutStatus } from "@redotech/cockroachdb-codegen/tables/redo-cart-checkout-status";
import { redoCartCheckoutIdFormat } from "@redotech/redo-ids/ids";
import { SuppliesPaymentMethodChoiceSchema } from "@redotech/redo-model/supplies";
import * as z from "zod";

// Places a ledger-billed supplies order: after a synchronous balance check, it
// signals the checkout's lifecycle workflow to place the order and awaits the
// result (the workflow debits the OMS ledger, creates the order, etc.).
export const placeSuppliesOrder = {
  name: "placeSuppliesOrder" as const,
  input: z.object({
    checkoutId: redoCartCheckoutIdFormat.schema,
    paymentMethod: SuppliesPaymentMethodChoiceSchema,
  }),
  output: z.discriminatedUnion("status", [
    z.object({
      status: z.literal(RedoCartCheckoutStatus.Completed),
      orderId: z.string(),
      orderName: z.string(),
    }),
    z.object({ status: z.literal(RedoCartCheckoutStatus.Expired) }),
  ]),
};
